import {PosType} from './index'

export const pos = process.env.REACT_APP_POS || PosType.bepoz
export const bpversion = '7.7.1'
export const app_secret = process.env.REACT_APP_APP_SECRET || ''
export const app_token = process.env.REACT_APP_APP_TOKEN || ''
export const recaptcha_key = process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''

// This api for production
export const API_URI = process.env.REACT_APP_API_URI || ''

// This api for DEV
// export const API_URI = 'https://dev.api4.vecport.net/api/'

// This api for yarravalleygrand
// export const API_URI = 'https://api3.vecport.net/yarravalleygrand/api/'

// This api for qa1
// export const API_URI = 'https://qa1.myplace.vecport.net/api/'

// This api for qa2
// export const API_URI = 'https://qa2.myplace.vecport.net/api/'

// This api for feature1
// export const API_URI = 'https://feature1.myplace.vecport.net/api/'

// This api for feature2
// export const API_URI = 'https://feature2.myplace.vecport.net/api/'

// This api for feature3
// export const API_URI = 'https://feature3.api4.vecport.net/api/'

// This api qa1swift
// export const API_URI = 'https://qa1.swiftpos.vecport.net/api/'

// This api for stagingmv
// export const API_URI = 'https://api.vecport.net/stagingmv/api/'

// This api for Redcape
// export const API_URI = 'https://apiredcape.vecport.net/publinc/api/'

// This api for huntergroup
// export const API_URI = 'https://api2.vecport.net/huntergroup/api/'

// This api for Hinchcliff House
// export const API_URI = 'https://api2.vecport.net/hinchcliffhouse/api/'

// This api for Doutta Galla
// export const API_URI = 'https://api2.vecport.net/douttagallahotel/api/'

// This api for Urban Alley
// export const API_URI = 'https://api2.vecport.net/urbanalleybrewery/api/'

// This api for Darlin Group
// export const API_URI = 'https://api2.vecport.net/darlingroup/api/'

// This api for Raffertys tavern
// export const API_URI = 'https://api2.vecport.net/raffertystavern/api/'

// This api for Waggarsl
// export const API_URI = 'https://api2.vecport.net/waggarsl/api/'

// This api for Elginn Inn
// export const API_URI = 'https://api.vecport.net/elgininn/api/'

// This api for Castellos
// export const API_URI = 'https://api2.vecport.net/castellos/api/'

// This api for Navy Canteen
// export const API_URI = 'https://apinavycanteen.vecport.net/navycanteen/api'

// This api for Urbanalleybrewery
// export const API_URI = 'https://api2.vecport.net/urbanalleybrewery/api/'

// This api for Brunetti
// export const API_URI = 'https://api2.vecport.net/brunetti/api/'

// This api for DemoNSW
// export const API_URI = 'https://api3.vecport.net/demonsw/api/'
